import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {useNavigate} from "react-router-dom";
import {LoggedInView} from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import {Link, useParams} from "react-router-dom";
import {
    createInsuranceRate,
    resetCreateInsuranceRateStatus,
} from "../../store/reducers/InsuranceRatesSlice";
import {RequestStatus} from "../../utils/Enums";
import {FormikProvider, useFormik, Form} from "formik";
import {createSMSSender} from "../../store/reducers/SMSSendersSlice";

interface NewInsuranceRateScreenProps {
}

export interface NewInsuranceRateFormProps {
    name: string;
}

export const NewInsuranceRateScreen: React.FC<NewInsuranceRateScreenProps> = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const insuranceRatesState = useAppSelector(
        (state) => state.insuranceRates
    );

    const requestStatus: RequestStatus =
        insuranceRatesState.createInsuranceRateStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Kindlustuse hinnad", url: "/insurance"},
        {text: "Lisa uus kindlustuse hind", url: "/insurance/new"},
    ];

    useEffect(() => {
        if (requestStatus === RequestStatus.Success) {
            dispatch(resetCreateInsuranceRateStatus());
            navigate(breadcrumbLinks[0].url);
        }
    }, [requestStatus]);

    // @ts-ignore
    const formik = useFormik({
        initialValues: {},
        onSubmit: (values: any) => {
            dispatch(createInsuranceRate(values));
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Failed &&
            insuranceRatesState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {insuranceRatesState.errors.map(
                            (error, index) => (
                                <span key={index}>
                                        {error}
                                    <br/>
                                    </span>
                            )
                        )}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>

                    <div className="form">
                        <h2>
                            <span>Kindlustuse hinna andmed</span>
                        </h2>
                        <table className="form">
                            <tbody>
                            <ElogInput
                                label="Hinnapiir"
                                name="price_limit"
                                mandatory={true}
                            />
                            <ElogInput
                                label="Hind"
                                name="price"
                                mandatory={true}
                            />
                            <ElogInput
                                label="Omavastutus"
                                name="own_responsibility"
                                mandatory={true}
                            />
                            <ElogInput
                                label="Poliisitasu"
                                name="policy_price"
                                mandatory={true}
                            />
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                                    <span>
                                        <strong>Sisesta</strong>
                                    </span>
                            </button>
                            <Link to="/insurance">Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    );
};